import React from 'react'

class VerificationTitleComponent extends React.Component {
  render () {
    return (
      <div style={styles.container}>
        <img src={this.props.img} alt='icon' style={styles.img} />
        <span style={styles.title}>{this.props.title}</span>
      </div>
    )
  }
}

const styles = {
  container: {
    marginTop: '20px',
    width: 'auto',
    height: '40px'
  },
  img: {
    float: 'left'
  },
  title: {
    marginLeft: '20px',
    fontSize: '32px',
    color: '#FFFFFF',
    fontWeight: 321,
    fontStyle: 'normal'
  }
}

export default VerificationTitleComponent
